import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectSettingsServicedeskCaseNotesEditRoute } from '@jira/router-routes__project-settings-service-desk-case-management-routes/src/projectSettingsServicedeskCaseNotesEditRoute.tsx';
import { caseNoteEditEntryPoint } from '@jira/spa-apps__project-settings-service-desk-case-note-edit/src/caseNoteEditEntryPoint.entrypoint.tsx';

const caseNoteEditPageEntryPoint = createPageEntryPoint({
	main: caseNoteEditEntryPoint,
});

export const projectSettingsServicedeskCaseNotesEditRouteEntry: Route = createEntry(
	projectSettingsServicedeskCaseNotesEditRoute,
	() => ({
		group: 'project-settings-servicedesk',
		entryPoint: () =>
			fg('jsm-case-management-settings') ? caseNoteEditPageEntryPoint : notFoundPageEntrypoint,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources()],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
